import { PermissionGate } from "@components/PermissionGate";
import { useState } from "react";
import { useTranslation } from "react-i18next";
import { useParams } from "react-router-dom";
import {
  ActionIcon,
  Group,
  Modal,
  ScrollAreaAutosize,
  Text,
  Tooltip,
} from "@mantine/core";
import { IconTrash } from "@tabler/icons-react";

import { formatDateToString } from "@utils/dateValidation";
import { truncateWithEllipsis } from "@utils/truncateText";

import { useDeleteSurgicalRecord } from "@hooks/mutations/patient/useDeleteSurgicalRecord";

import { PatientSurgicalHistoryItem } from "@customTypes/patient";

import { StyledFullSurgicalHistoryModal } from "./FullSurgicalHistoryModal.styled";


interface FullSurgicalHistoryDialogProps {
  surgeries?: PatientSurgicalHistoryItem[];
  opened: boolean;
  close: () => void;
}

export const FullSurgicalHistoryModal = ({
  surgeries = [],
  opened,
  close,
}: FullSurgicalHistoryDialogProps) => {
  const { t } = useTranslation();
  // const test = [...surgeries, ...surgeries];
  const { patientId } = useParams();

  const [currentId, setCurrentId] = useState("");
  const { mutate: deleteSurgicalRecord, isLoading: isDeletingSurgicalRecord } =
    useDeleteSurgicalRecord();

  return (
    <Modal
      centered
      title={<Text fw={500}>{t("full-surgical-history")}</Text>}
      opened={opened}
      onClose={close}
      scrollAreaComponent={ScrollAreaAutosize}>
      <StyledFullSurgicalHistoryModal>
        <ul className="timeline">
          {surgeries.map(({ date, surgery, id }, index) => (
            <li className="timeline-item" key={index}>
              <span className="date">{formatDateToString(date).slice(-7)}</span>
              <span aria-hidden className="decor"></span>
              <Group gap={"xs"}>
                <p className="name" title={surgery.length > 30 ? surgery : ""}>
                  {truncateWithEllipsis(surgery, 30)}
                </p>
                <Tooltip
                  withArrow
                  events={{ focus: true, hover: true, touch: true }}
                  label={t("delete")}>
                  <PermissionGate permission="consultations.delete"><ActionIcon
                    size={"sm"}
                    variant="outline"
                    color="red"
                    loading={isDeletingSurgicalRecord && currentId === id}
                    className="delete-btn"
                    onClick={() => {
                      setCurrentId(id);
                      deleteSurgicalRecord({
                        surgeryId: id,
                        patientId: patientId as string,
                      });
                    }}>
                    <IconTrash size={14} />
                  </ActionIcon></PermissionGate>
                </Tooltip>
              </Group>
            </li>
          ))}
        </ul>
      </StyledFullSurgicalHistoryModal>
    </Modal>
  );
};
